export default __webpack_public_path__ + "static/media/project-management.e0da2530.png";